import * as React from 'react';
import { includes } from 'lodash';
import NumericInput from './numeric_input';
import Currency from './currency';

const UNSUPPORTED_FA_ICONS = ['AUD', 'CAD'];

class PriceFieldWithCurrency extends React.Component {
  renderSymbol = () => {
    const currencyForIcon = includes(UNSUPPORTED_FA_ICONS, this.props.currency) ? 'usd' : this.props.currency;
    if (!currencyForIcon) { return null; }

    const iconClasses = `fa fa-${currencyForIcon.toLowerCase()}`;

    return (
      <span
        className="input-group__text"
        data-price-with-currency-symbol
      >
        <span className={iconClasses} />
      </span>
    );
  };

  // eslint-disable-next-line
  input = () => { this.refs.input.refs.input; };

  renderCode = () => {
    if (!Currency.isInternational(this.props.currency)) { return false; }

    return (
      <span
        className="input-group__text"
        data-price-with-currency-currency
      >
        {this.props.currency}
      </span>
    );
  };

  render() {
    return (
      <div className="input-group">
        {this.renderSymbol()}
        <NumericInput
          {...this.props}
          className="input-group__input"
          ref="input"
        />
        {this.renderCode()}
      </div>
    );
  }
}

export default PriceFieldWithCurrency;



// WEBPACK FOOTER //
// ./javascripts/components/shared/price_field_with_currency.jsx